import React from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import Home from './components/Home';
import AdminPanel from './components/AdminPanel';
import Error500 from './components/commons/Error500';
import theme from './theme';
import history from './utils/helper_functions/history';

export default function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <div>
          <Router history={history}>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/admin-panel" component={AdminPanel} />
              <Route exact path="/500" component={Error500} />
            </Switch>
          </Router>
        </div>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
